import React from "react";
import { ReactComponent as AatLogo } from "../../../aat/assets/icons/aat-logo.svg";
import { ReactComponent as AatLogoNew } from "../../../aat/assets/icons/at-cirkel-logo.svg";
import { ReactComponent as AatLogotype } from "../../../aat/assets/icons/aat-logotype.svg";
import { ReactComponent as AatLogotypeNew } from "../../../aat/assets/icons/at-logoer-3.svg";
import { ReactComponent as ArrowDown } from "../../../aat/assets/icons/arrow-down.svg";
import { ReactComponent as ArrowLeft } from "../../../aat/assets/icons/arrow-left.svg";
import { ReactComponent as ArrowRight } from "../../../aat/assets/icons/arrow-right.svg";
import { ReactComponent as ArrowUp } from "../../../aat/assets/icons/arrow-up.svg";
import { ReactComponent as ArrowDownLine } from "../../../aat/assets/icons/arrow-down-line.svg";
import { ReactComponent as ArrowLeftLine } from "../../../aat/assets/icons/arrow-left-line.svg";
import { ReactComponent as ArrowRightLine } from "../../../aat/assets/icons/arrow-right-line.svg";
import { ReactComponent as ArrowUpLine } from "../../../aat/assets/icons/arrow-line-up.svg";
import { ReactComponent as Bag } from "../../../aat/assets/icons/bag.svg";
import { ReactComponent as Bookmark } from "../../../aat/assets/icons/bookmark.svg";
import { ReactComponent as Calendar } from "../../../aat/assets/icons/calendar.svg";
import { ReactComponent as Circle } from "../../../aat/assets/icons/cirkel.svg";
import { ReactComponent as Checkmark } from "../../../aat/assets/icons/checkmark.svg";
import { ReactComponent as Close } from "../../../aat/assets/icons/close.svg";
import { ReactComponent as Document } from "../../../aat/assets/icons/document.svg";
import { ReactComponent as Download } from "../../../aat/assets/icons/download.svg";
import { ReactComponent as Edit } from "../../../aat/assets/icons/edit.svg";
import { ReactComponent as Facebook } from "../../../aat/assets/icons/facebook.svg";
import { ReactComponent as FavoritFull } from "../../../aat/assets/icons/favorit-full.svg";
import { ReactComponent as FavoritStroke } from "../../../aat/assets/icons/favorit-stroke.svg";
import { ReactComponent as Filter } from "../../../aat/assets/icons/filter.svg";
import { ReactComponent as FullScreen } from "../../../aat/assets/icons/full-screen.svg";
import { ReactComponent as Globe } from "../../../aat/assets/icons/globe.svg";
import { ReactComponent as Gallery } from "../../../aat/assets/icons/gallery.svg";
import { ReactComponent as Hide } from "../../../aat/assets/icons/hide.svg";
import { ReactComponent as Home } from "../../../aat/assets/icons/home.svg";
import { ReactComponent as Image } from "../../../aat/assets/icons/image.svg";
import { ReactComponent as Instagram } from "../../../aat/assets/icons/instagram.svg";
import { ReactComponent as Link } from "../../../aat/assets/icons/link.svg";
import { ReactComponent as Login } from "../../../aat/assets/icons/login.svg";
import { ReactComponent as Mail } from "../../../aat/assets/icons/mail.svg";
import { ReactComponent as MapPin } from "../../../aat/assets/icons/map-pin.svg";
import { ReactComponent as Minus } from "../../../aat/assets/icons/minus.svg";
import { ReactComponent as Pause } from "../../../aat/assets/icons/pause.svg";
import { ReactComponent as Phone } from "../../../aat/assets/icons/phone.svg";
import { ReactComponent as Phone2 } from "../../../aat/assets/icons/phone2.svg";
import { ReactComponent as Pil } from "../../../aat/assets/icons/pil.svg";
import { ReactComponent as Play } from "../../../aat/assets/icons/play.svg";
import { ReactComponent as Plus } from "../../../aat/assets/icons/plus.svg";
import { ReactComponent as Print } from "../../../aat/assets/icons/print.svg";
import { ReactComponent as Quote } from "../../../aat/assets/icons/quote.svg";
import { ReactComponent as SafePayment } from "../../../aat/assets/icons/safe-payment.svg";
import { ReactComponent as Search } from "../../../aat/assets/icons/search.svg";
import { ReactComponent as Share } from "../../../aat/assets/icons/share.svg";
import { ReactComponent as Show } from "../../../aat/assets/icons/show.svg";
import { ReactComponent as SmallScreen } from "../../../aat/assets/icons/small-screen.svg";
import { ReactComponent as Time } from "../../../aat/assets/icons/time.svg";
import { ReactComponent as Trash } from "../../../aat/assets/icons/trash.svg";
import { ReactComponent as Weather } from "../../../aat/assets/icons/weather.svg";
import { ReactComponent as Youtube } from "../../../aat/assets/icons/youtube.svg";
import { ReactComponent as ArrowCircleDown } from "../../../aat/assets/icons/arrow-circle-down.svg";
import { ReactComponent as ArrowCircleUp } from "../../../aat/assets/icons/arrow-circle-up.svg";
import { ReactComponent as ArrowCircleLeft } from "../../../aat/assets/icons/arrow-circle-left.svg";
import { ReactComponent as ArrowCircleRight } from "../../../aat/assets/icons/arrow-circle-right.svg";
import { ReactComponent as Scala } from "../../../aat/assets/icons/scala.svg";
import { ReactComponent as ScalaLarge } from "../../../aat/assets/icons/scala--large.svg";
import { ReactComponent as StoreScene } from "../../../aat/assets/icons/store-scene.svg";
import { ReactComponent as StoreSceneLarge } from "../../../aat/assets/icons/store-scene--large.svg";
import { ReactComponent as Studio } from "../../../aat/assets/icons/studio.svg";
import { ReactComponent as Star } from "../../../aat/assets/icons/star.svg";
import { ReactComponent as Stiklingen } from "../../../aat/assets/icons/stiklingen.svg";
import { ReactComponent as StiklingenLarge } from "../../../aat/assets/icons/stiklingen--large.svg";
import styled, { keyframes } from "styled-components";

interface Props {
    name: string;
    className?: string;
}

const FadeIn = keyframes`
     0% { opacity: 0; transform: scale(0); }
     100% { opacity: 1; transform: scale(1);}
`;

const IconWrap = styled.span`
    display: inline-block;
    svg {
        fill: currentColor;
        stroke: currentColor;
        pointer-events: none;
        animation: ${FadeIn} .15s forwards;
    }
`;

/*
    This is just a temporary solution for icon management.
    Ideally a spritesheet would be preferable so it only makes 1 request,
    but let's see what moving in the frontend world when the times comes.
*/
const Icon: React.FunctionComponent<Props> = (props) => {
    switch (props.name) {
        case "aat-logo":
            return <IconWrap><AatLogo className={props.className} /></IconWrap>;
        case "aat-logo-new":
            return <IconWrap><AatLogoNew className={props.className} /></IconWrap>;
        case "aat-logotype":
            return <IconWrap><AatLogotype className={props.className} /></IconWrap>;
        case "aat-logotype-new":
            return <IconWrap><AatLogotypeNew className={props.className} /></IconWrap>;
        case "arrow-left":
            return <IconWrap><ArrowLeft className={props.className} /></IconWrap>;
        case "arrow-down":
            return <IconWrap><ArrowDown className={props.className} /></IconWrap>;
        case "arrow-right":
            return <IconWrap><ArrowRight className={props.className} /></IconWrap>;
        case "arrow-up":
            return <IconWrap><ArrowUp className={props.className} /></IconWrap>;
        case "arrow-left-line":
            return <IconWrap><ArrowLeftLine className={props.className} /></IconWrap>;
        case "arrow-down-line":
            return <IconWrap><ArrowDownLine className={props.className} /></IconWrap>;
        case "arrow-right-line":
            return <IconWrap><ArrowRightLine className={props.className} /></IconWrap>;
        case "arrow-up-line":
            return <IconWrap><ArrowUpLine className={props.className} /></IconWrap>;
        case "bag":
            return <IconWrap><Bag className={props.className} /></IconWrap>;
        case "bookmark":
            return <IconWrap><Bookmark className={props.className} /></IconWrap>;
        case "calendar":
            return <IconWrap><Calendar className={props.className} /></IconWrap>;
        case "circle":
            return <IconWrap><Circle className={props.className} /></IconWrap>;
        case "checkmark":
            return <IconWrap><Checkmark className={props.className} /></IconWrap>;
        case "close":
            return <IconWrap><Close className={props.className} /></IconWrap>;
        case "document":
            return <IconWrap><Document className={props.className} /></IconWrap>;
        case "download":
            return <IconWrap><Download className={props.className} /></IconWrap>;
        case "edit":
            return <IconWrap><Edit className={props.className} /></IconWrap>;
        case "facebook":
            return <IconWrap><Facebook className={props.className} /></IconWrap>;
        case "favorite-full":
            return <IconWrap><FavoritFull className={props.className} /></IconWrap>;
        case "favorite-stroke":
            return <IconWrap><FavoritStroke className={props.className} /></IconWrap>;
        case "filter":
            return <IconWrap><Filter className={props.className} /></IconWrap>;
        case "full-screen":
            return <IconWrap><FullScreen className={props.className} /></IconWrap>;
        case "globe":
            return <IconWrap><Globe className={props.className} /></IconWrap>;
        case "gallery":
            return <IconWrap><Gallery className={props.className} /></IconWrap>;
        case "hide":
            return <IconWrap><Hide className={props.className} /></IconWrap>;
        case "home":
            return <IconWrap><Home className={props.className} /></IconWrap>;
        case "image":
            return <IconWrap><Image className={props.className} /></IconWrap>;
        case "instagram":
            return <IconWrap><Instagram className={props.className} /></IconWrap>;
        case "login":
            return <IconWrap><Login className={props.className} /></IconWrap>;
        case "link":
            return <IconWrap><Link className={props.className} /></IconWrap>;
        case "mail":
            return <IconWrap><Mail className={props.className} /></IconWrap>;
        case "map-pin":
            return <IconWrap><MapPin className={props.className} /></IconWrap>;
        case "minus":
            return <IconWrap><Minus className={props.className} /></IconWrap>;
        case "pause":
            return <IconWrap><Pause className={props.className} /></IconWrap>;
        case "phone":
            return <IconWrap><Phone className={props.className} /></IconWrap>;
        case "phone2":
            return <IconWrap><Phone2 className={props.className} /></IconWrap>;
        case "pil":
            return <IconWrap><Pil className={props.className} /></IconWrap>;
        case "play":
            return <IconWrap><Play className={props.className} /></IconWrap>;
        case "plus":
            return <IconWrap><Plus className={props.className} /></IconWrap>;
        case "print":
            return <IconWrap><Print className={props.className} /></IconWrap>;
        case "quote":
            return <IconWrap><Quote className={props.className} /></IconWrap>;
        case "safe-payment":
            return <IconWrap><SafePayment className={props.className} /></IconWrap>;
        case "search":
            return <IconWrap><Search className={props.className} /></IconWrap>;
        case "share":
            return <IconWrap><Share className={props.className} /></IconWrap>;
        case "show":
            return <IconWrap><Show className={props.className} /></IconWrap>;
        case "small-screen":
            return <IconWrap><SmallScreen className={props.className} /></IconWrap>;
        case "time":
            return <IconWrap><Time className={props.className} /></IconWrap>;
        case "trash":
            return <IconWrap><Trash className={props.className} /></IconWrap>;
        case "weather":
            return <IconWrap><Weather className={props.className} /></IconWrap>;
        case "youtube":
            return <IconWrap><Youtube className={props.className} /></IconWrap>;
        case "arrow-circle-down":
            return <IconWrap><ArrowCircleDown className={props.className} /></IconWrap>;
        case "arrow-circle-up":
            return <IconWrap><ArrowCircleUp className={props.className} /></IconWrap>;
        case "arrow-circle-left":
            return <IconWrap><ArrowCircleLeft className={props.className} /></IconWrap>;
        case "arrow-circle-right":
            return <IconWrap><ArrowCircleRight className={props.className} /></IconWrap>;
        case "scala":
            return <IconWrap><Scala className={props.className} /></IconWrap>;
        case "scala--large":
            return <IconWrap><ScalaLarge className={props.className} /></IconWrap>;
        case "studio":
            return <IconWrap><Studio className={props.className} /></IconWrap>;
        case "store-scene":
            return <IconWrap><StoreScene className={props.className} /></IconWrap>;
        case "store-scene--large":
            return <IconWrap><StoreSceneLarge className={props.className} /></IconWrap>;
        case "star":
            return <IconWrap><Star className={props.className} /></IconWrap>;
        case "stiklingen":
            return <IconWrap><Stiklingen className={props.className} /></IconWrap>;
        case "stiklingen--large":
            return <IconWrap><StiklingenLarge className={props.className} /></IconWrap>;
    }
    return null;
};

export default Icon;
